import { render, staticRenderFns } from "./VariantSifterS2gDrawer.vue?vue&type=template&id=5de15dd1&scoped=true&"
import script from "./VariantSifterS2gDrawer.vue?vue&type=script&lang=js&"
export * from "./VariantSifterS2gDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterS2gDrawer.vue?vue&type=style&index=0&id=5de15dd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de15dd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de15dd1')) {
      api.createRecord('5de15dd1', component.options)
    } else {
      api.reload('5de15dd1', component.options)
    }
    module.hot.accept("./VariantSifterS2gDrawer.vue?vue&type=template&id=5de15dd1&scoped=true&", function () {
      api.rerender('5de15dd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterS2gDrawer.vue"
export default component.exports